/** Matches Twilio Voice `Device` / loglevel `LogLevelNumbers` (0–5). */
export type TwilioVoiceSdkLogLevel = 0 | 1 | 2 | 3 | 4 | 5;

/**
 * Maps `REACT_APP_TWILIO_VOICE_LOG_LEVEL` to Twilio Voice SDK `Device` logLevel (number).
 * SDK: 0 = trace, 1 = debug, 2 = info, 3 = warn, 4 = error, 5 = silent.
 *
 * Accepts a number 0–5 or names: trace, debug, info, warn, error, silent (case-insensitive).
 * When unset or invalid, defaults to 1 (debug) — same as the previous hard-coded Device option.
 */
export function resolveTwilioVoiceLogLevel(): TwilioVoiceSdkLogLevel {
  const raw = process.env.REACT_APP_TWILIO_VOICE_LOG_LEVEL;
  if (raw === undefined || String(raw).trim() === '') {
    return 1;
  }

  const s = String(raw).trim().toLowerCase();
  const named: Record<string, TwilioVoiceSdkLogLevel> = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    warning: 3,
    error: 4,
    silent: 5,
    none: 5,
    off: 5,
  };
  if (s in named) {
    return named[s];
  }

  const n = Number(s);
  if (!Number.isNaN(n) && n >= 0 && n <= 5 && Number.isInteger(n)) {
    return n as TwilioVoiceSdkLogLevel;
  }

  return 1;
}
